import { FormAtylBase } from '../../form-atyl-base'

export class AtylEmail extends FormAtylBase<string> {
	controlType = 'email'
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
